import * as React from "react";
const SvgStatusIndicatorCircleIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 50, r: 50 }));
export default SvgStatusIndicatorCircleIcon;
